import React from 'react';

import { withPrefix } from 'gatsby-link';

//import jquery from 'jquery'
import $ from 'jquery';

// window.jQuery = $;
// window.$ = $;
//window.jQuery = jQuery;

//require('bootstrap');

import './_accordion.scss';


class Accordion extends React.Component {

  constructor(props) {
    super(props);
  }

  //==============
  // React Methods
  //==============

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();

    require('bootstrap');

    // if (typeof jQuery == 'undefined') {
    //   console.log('jquery not loaded');
    // } else {
    //   console.log('jquery loaded');
    // }

    var jqueryDOM = $('.features-title').text();
    console.log(jqueryDOM);

  }

  componentDidUpdate (){
    this.aos.refresh();
  }

  //=================
  // Render Component
  //=================

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12">

            <section class="accordion-container">
              {this.props.data.map((item, index, accordionIndex) => (

                accordionIndex = 'accordian-' + index,

                <div key={index} className="accordion" id={accordionIndex}>
                  <h3>{item.group}</h3>
                  {item.faq_list.map( (faq, index, cardHeadingIndex, cardCollapseIndex) => (

                    cardHeadingIndex = accordionIndex + '-heading-'+ index,
                    cardCollapseIndex = accordionIndex + '-collapse-'+ index,

                      <div key={index} className="card">
                        <div className="card-header collapsed" id={cardHeadingIndex} data-toggle="collapse" data-target={'#'+ cardCollapseIndex} aria-expanded="true" aria-controls={cardCollapseIndex}>
                          <h5 className="mb-0">
                            {faq.question}
                          </h5>
                        </div>
                        <div id={cardCollapseIndex} className="collapse" aria-labelledby={cardHeadingIndex} data-parent={'#' + accordionIndex}>
                          <div className="card-body">
                            <p>{faq.answer}</p>
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              ))}
            </section>

            {/* <ul className="features-list">
              {this.props.data.map( (item, index) => (
                <li className="features-list-item" key={index}>
                  {item.group}
                  {index}
                    {item.faq_list.map( (faq, index) => (
                      <div>
                      {index}
                      {faq.question}
                      {faq.answer}
                      </div>
                    ))}
                </li>
                ))}
            </ul> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Accordion;


// const Accordion = props =>
//   (<section classNameName="features" id="features">
//     <div classNameName="container">
//       <div classNameName="row">
//         <div classNameName="col-12">
//           <h4 className="features-title">Accordion</h4>
//         </div>
//       </div>
//       <div className="row">
//         <div className="col-12">
//           <ul className="features-list">
//             {props.data.map((item, i) =>
//               (<li className="features-list-item" key={i}>
//                 {item.section}
//                 {item.accordion_id}
//                 {i}
//               </li>),
//             )}
//           </ul>
//         </div>
//       </div>
//     </div>
//   </section>);

//export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Accordion/index.js